import { render, staticRenderFns } from "./KbAndImunizationHistory.vue?vue&type=template&id=cadb5c3a&scoped=true"
import script from "./KbAndImunizationHistory.vue?vue&type=script&lang=js"
export * from "./KbAndImunizationHistory.vue?vue&type=script&lang=js"
import style0 from "./KbAndImunizationHistory.vue?vue&type=style&index=0&id=cadb5c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadb5c3a",
  null
  
)

export default component.exports